import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-add-goal-dialog',
    templateUrl: './add-goal-dialog.component.html',
    styleUrls: ['./add-goal-dialog.component.css'],
    standalone: false
})
export class AddGoalDialogComponent {
  dialogTitle = 'Add Goal';

  goal = { title: '' };
  targetInput = '';
  currentInput = '';

  constructor(
    private ref: MatDialogRef<AddGoalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.dialogTitle = data.isEdit ? 'Edit Goal' : 'Add Goal';
      this.goal.title = data.title || '';
      this.targetInput = data.target && data.targetname ? `${data.target} ${data.targetname}` : '';
      this.currentInput = data.current ? `${data.current} ${data.targetname}` : '';
    }
  }

  

  private splitValueUnit(str: string) {
    const [valuePart, ...unitParts] = str.trim().split(/\s+/);
    return {
      value: Number(valuePart),
      unit: unitParts.join(' ').trim() || 'units'
    };
  }

  onCancel() {
    this.ref.close();
  }

  onSave() {
    const tgt = this.splitValueUnit(this.targetInput);
    const cur = this.currentInput ? this.splitValueUnit(this.currentInput) : { value: 0, unit: tgt.unit };

    this.ref.close({
      title: this.goal.title,
      target: tgt.value,
      current: cur.value,
      targetname: tgt.unit
    });
  }
}
